import Date from '../prototypes/Date';
import merge from "../functions/merge";

export default {
	entity() {
		return merge({}, {
			_embedded: {
				contact: {
					name: '',
					address: '',
					zip: '',
					city: ''
				},
				tasks: []
			},
			contact_id: null,
			department_id: null,
			employee_id: null,
			name: '',
			phone: '',
			email: '',
			comments: '',
			motivation: '',
			source: 'employee',
			status: 'new',
			contact: [],
			details: {
				files: [],
				date: (new Date()).format('Y-m-d'),
				type: 'private',
				area: '',
				address: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				dest: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
			}
		});
	},
	save(axios, entity) {
		return new Promise(function (resolve) {
			if (entity.id) {
				

				axios
					.put('/sales/leads/' + entity.id + '/', entity)
					.then(function (r) {
						

						resolve(r.data);
					}, function () {
						
					});
			} else {
				axios
					.post('/sales/leads/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		return new Promise(function (resolve) {
			axios
				.get('/sales/leads/' + id + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/sales/leads/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	}
};